import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeedbackModalService } from '@app/utils/services/feedback-modal.service';

@Component({
  selector: 'app-feedback-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './feedback-modal.component.html',
  styleUrl: './feedback-modal.component.scss',
})
export class FeedbackModalComponent {
  protected readonly modal = inject(FeedbackModalService);
  // Scope obligatorio para data-testid; el padre lo provee según su contexto.
  @Input({ required: true }) testIdScope!: string;

  protected tid(suffix: string): string {
    return `${this.testIdScope}-dialog-feedback-${suffix}`;
  }

  onClose(): void {
    this.modal.hide();
  }

  onButtonClick(): void {
    if (this.modal.isConfirm() || this.modal.isPrompt()) {
      this.modal.confirm();
    } else {
      this.modal.hide();
    }
  }

  onCancelClick(): void {
    this.modal.hide();
  }

  onOverlayClick(): void {
    this.onClose();
  }

  onModalClick(event: Event): void {
    event.stopPropagation();
  }

  onPromptInput(event: Event): void {
    const target = event.target as HTMLTextAreaElement;
    this.modal.setPromptValue(target.value);
  }
}
